/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Sponsor_Edit_LabelInputs */



/**
* | output |
* | --- |
* | "Sponsor: {name}" |
*
* @param {Sponsor_Edit_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sponsor_edit_label = /** @type {((inputs: Sponsor_Edit_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sponsor_Edit_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Parrain : ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Avalista: ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Padrinho: ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sponsor: ${i?.name}`)
	return /** @type {LocalizedString} */ (`Sponsor: ${i?.name}`)
});